module.exports = "/assets/d2e859bf891f053c0ba1f84020f3b92e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/OV.png
// module id = 2818
// module chunks = 0